.drip-sequence-grid {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto;
    gap: 12px;
    align-items: start;
    min-width: 500px;
    word-break: break-word;
    padding-top: 8px;
}

.drip-sequence-grid-problem {
    grid-template-rows: unset;
}

.drip-icon-container {
    grid-column: 1;
    grid-row: 1;
    display: flex;
    align-items: flex-start;
    padding-top: 4px;
}

.header-container {
    grid-column: 2;
    grid-row: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    position: relative;
}

.vertical-line-container {
    grid-column: 1;
    grid-row: 2;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.left-vertical-line {
    width: 1px;
    background-color: var(--grey-lt);
    margin-top: 4px;
    position: relative;
}

.left-vertical-line::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 6px solid var(--grey-lt);
}

.email-rows-cell {
    grid-column: 2 / 4;
    grid-row: 2;
    gap: 12px;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.toolbar-container {
    position: absolute;
    top: -8px;
    right: 8px;
}
